import { getApp } from "owa-config";
import { redirectToOwa } from "./redirectToOwa";
import { redirect, redirectTo, AUTH_REDIRECT_KEY, MSAL_AUTH_REDIRECT_KEY } from "./redirect";
import type { BootError, BootResult } from "owa-shared-start-types";
import type ErrorDiagnostics from "./interfaces/ErrorDiagnostics";
import handleErrorLocally from "./handleErrorLocally";
import { isMsalFlowEnabled } from "owa-msaljs/lib/isMsalFlowEnabled";
import { setAuthTiming } from "owa-auth-timings";
import { getAadOrMsaRedirectUri } from "owa-msaljs/lib/utils/getAadOrMsaRedirectUri";
import { generateAndStoreRedirectSid } from "owa-msaljs/lib/utils/marketingRedirectSid";
import { getLocalizedMarketingPageUrl } from "owa-msaljs/lib/utils/getLocalizedMarketingPageUrl";
import { isBootFeatureEnabled } from "owa-metatags";

export function handleBootError(bootResult: BootResult, error: BootError, errorDiagnostics: ErrorDiagnostics, onFatalBootError?: () => void, skipAuthRedirect = false): void {
    // Check if we need retry before render error page
    let didRedirect: boolean = false;
    if (bootResult == "langtz") {
        redirectToOwa(getApp());
        return;
    }
    else if (bootResult == "errorfe" && error.response?.url) {
        redirectTo(error.response.url);
        return;
    }
    else if (bootResult == "auth" && !skipAuthRedirect) {
        setAuthTiming("bootred");
        didRedirect = isMsalFlowEnabled()
            ? redirect(location, MSAL_AUTH_REDIRECT_KEY, "true")
            : redirect(location, AUTH_REDIRECT_KEY, "true", undefined, true, error?.response?.headers);
    }
    else if (bootResult == "nlp") {
        // Redirect directly to the marketing page with correct locale instead of going through OwaWebServer.
        // Loop detection and telemetry are handled upstream in onBootError via appendMiscData.
        // Explicitly generate/store the sid here so the caller controls when the side effect happens.
        const sid = isBootFeatureEnabled("auth-consumerLoginLoopDetection")
            ? generateAndStoreRedirectSid()
            : undefined;
        redirectTo(getLocalizedMarketingPageUrl(sid));
        return;
    }
    else if (bootResult == "aadmsaredir") {
        redirectTo(getAadOrMsaRedirectUri());
        return;
    }
    
    if (!didRedirect) {
        // Await this because once we redirect further async stuff won't happen
        onFatalBootError?.();
        handleErrorLocally(bootResult, errorDiagnostics, error);
    }
}
